/* ============================================================
   Beneos: Bewegung mit Bremse. WCAG 2.1, Kriterium 2.2.2.

   Die Startseite spielt mehrere Videos selbsttaetig und in
   Endlosschleife. Wer das nicht will oder nicht vertraegt,
   braucht einen Weg, es anzuhalten. Dieses Skript liefert ihn.

   Drei Regeln:
     1. Wer im Betriebssystem reduzierte Bewegung eingestellt
        hat, bekommt gar keinen Selbststart. Das Standbild
        (poster) bleibt stehen.
     2. Der Schalter erscheint nur, wenn es ueberhaupt etwas
        anzuhalten gibt.
     3. Die Wahl haelt ueber Seitenwechsel hinweg.

   Das Skript greift in keinen bestehenden Handler ein. Es
   hoert auf das play-Ereignis, statt fremde Aufrufe zu
   ersetzen: laeuft der Pausenzustand, wird jedes anlaufende
   Video sofort wieder angehalten, ganz gleich wer es
   gestartet hat.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'beneos-motion';
  var root = document.documentElement;
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  var stored = null;
  try { stored = localStorage.getItem(KEY); } catch (e) { /* privater Modus */ }

  // Reduzierte Bewegung gewinnt, solange niemand ausdruecklich widersprochen hat.
  var paused = stored ? (stored === 'paused') : reduced;

  var btn = document.getElementById('beneos-motion-toggle');

  // Angehalten wird nur, was auch lief, und fortgesetzt wird nur, was
  // wir selbst angehalten haben. Die Startseite pausiert einzelne
  // Videos aus eigenem Antrieb (der Szenenumschalter zeigt immer nur
  // eines). Wer beim Fortsetzen pauschal alles startet, macht aus
  // einer Bremse einen Beschleuniger.
  // merken = "das lief, als der Nutzer angehalten hat". Nur solche
  // Videos laufen beim Fortsetzen wieder an. Ein play()-Versuch
  // waehrend der Pause wird abgewiesen, ohne sich einen Merkposten zu
  // setzen; sonst sammelt sich jedes einzelne Video an, das ein
  // fremdes Skript zwischendurch anzustossen versucht, und beim
  // Fortsetzen laufen ploetzlich alle gleichzeitig.
  function stopVideo(v, merken) {
    if (!v.paused) {
      if (merken) v.setAttribute('data-beneos-stopped', '');
      try { v.pause(); } catch (e) {}
    }
  }

  function startVideo(v) {
    if (!v.hasAttribute('data-beneos-stopped')) return;
    v.removeAttribute('data-beneos-stopped');
    var p = v.play();
    if (p && p.catch) p.catch(function () { /* Browser darf ablehnen */ });
  }

  function claim(v) {
    if (v.hasAttribute('data-beneos-motion-seen')) return;
    v.setAttribute('data-beneos-motion-seen', '');
    // Nur selbststartende Videos gehen uns etwas an. Ein Trailer, den
    // jemand bewusst angeklickt hat, ist kein Fall fuer 2.2.2.
    if (v.autoplay || v.hasAttribute('autoplay')) v.setAttribute('data-beneos-auto', '');
    v.addEventListener('play', function () {
      if (paused && v.hasAttribute('data-beneos-auto')) stopVideo(v, false);
    });
    if (paused && v.hasAttribute('data-beneos-auto')) stopVideo(v, false);
  }

  function scan() {
    var vids = document.querySelectorAll('video');
    for (var i = 0; i < vids.length; i++) claim(vids[i]);
    return document.querySelectorAll('video[data-beneos-auto]').length;
  }

  function apply() {
    root.setAttribute('data-beneos-motion', paused ? 'paused' : 'playing');
    var vids = document.querySelectorAll('video[data-beneos-auto]');
    for (var i = 0; i < vids.length; i++) {
      if (paused) stopVideo(vids[i], true); else startVideo(vids[i]);
    }
    if (btn) {
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      var lab = paused ? btn.getAttribute('data-label-play') : btn.getAttribute('data-label-pause');
      btn.setAttribute('aria-label', lab);
      var t = btn.querySelector('.bmt-t');
      if (t) t.textContent = lab;
    }
  }

  function showIfNeeded() {
    if (!btn) return;
    btn.hidden = scan() === 0;
  }

  if (btn) {
    btn.addEventListener('click', function () {
      paused = !paused;
      try { localStorage.setItem(KEY, paused ? 'paused' : 'playing'); } catch (e) {}
      apply();
    });
  }

  scan();
  apply();
  showIfNeeded();

  // Videos koennen nachgeliefert werden (Explorer, Suchbrowser, Modals).
  // Der Beobachter sieht sich nur die tatsaechlich hinzugekommenen
  // Knoten an und arbeitet gedrosselt. Ein Durchlauf ueber das ganze
  // Dokument bei jeder DOM-Aenderung wuerde eine Seite mit viel
  // Nachladen sichtbar ausbremsen.
  if (window.MutationObserver) {
    var wartet = false;
    new MutationObserver(function (records) {
      var relevant = false;
      for (var i = 0; i < records.length && !relevant; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.tagName === 'VIDEO' || (n.querySelector && n.querySelector('video'))) {
            relevant = true; break;
          }
        }
      }
      if (!relevant || wartet) return;
      wartet = true;
      setTimeout(function () {
        wartet = false;
        scan();
        if (paused) apply();
        showIfNeeded();
      }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  // Aendert jemand die Systemeinstellung, ohne je selbst geschaltet zu
  // haben, folgen wir ihr.
  if (window.matchMedia) {
    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var onChange = function (e) {
      var hasChoice = false;
      try { hasChoice = !!localStorage.getItem(KEY); } catch (err) {}
      if (hasChoice) return;
      paused = e.matches;
      apply();
    };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);
  }
})();
